import { ShieldOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * 403 page. Rendered in place rather than redirecting, so the user learns
 * *why* the screen is unavailable instead of being silently bounced.
 */
export function Forbidden() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <ShieldOff className="text-ink-subtle size-10" aria-hidden />
      <h1 className="text-lg font-semibold">{t('states.forbidden')}</h1>
      <p className="text-ink-muted max-w-md text-sm">{t('states.forbiddenHint')}</p>
    </div>
  );
}
